import { DailyAudioTrack, useDaily, useParticipantIds } from '@daily-co/daily-react'
import classNames from '@ui-components-3/ui/lib/utils/classNames'
import ParticipantsView from './ParticipantsView'
import DailyVideoActions from './DailyVideoActions'

type DailyVideoChatProps = {
  className?: string
  compact?: boolean
  actions: {
    chat: () => void
    hangup: () => void
    settings: () => void
    chatBadgeValue?: string | number
  }
}

const ParticipantsAudio = () => {
  const otherParticipantsIds = useParticipantIds({ filter: 'remote' })
  return (
    <>
      {otherParticipantsIds.map((sessionId) => {
        return <DailyAudioTrack key={sessionId} sessionId={sessionId} />
      })}
    </>
  )
}

const DailyVideoChat = ({ compact, className, actions }: DailyVideoChatProps) => {
  const callObject = useDaily()

  if (!callObject) {
    return 'Loading...'
  }

  return (
    <div
      className={classNames(
        'w-auto max-w-[828px] max-h-[100%] flex items-center justify-center relative',
        !compact && ' min-w-[300px] min-h-max',
        className,
      )}
    >
      <ParticipantsView compact={compact} onHangup={actions?.hangup} />
      {!compact && <DailyVideoActions actions={actions} />}
      <ParticipantsAudio />
    </div>
  )
}

export default DailyVideoChat
